import './ProfileCircle.scss';

export interface IPersonaProps {
  name: string;
}

const ProfileCircle = (props: IPersonaProps) => {
  const { name } = props;

  let userName = '';

  if (name) {
    const nameArr = name.split(' ');
    const bufferNameArr = nameArr.filter((char) => char && char !== '' && char !== ' ');

    if (bufferNameArr.length > 0) {
      const [firstName, ...lastNameArr] = bufferNameArr;
      const lastName = lastNameArr.join(' ');
      const firstNameSliced = firstName.slice(0, 1);
      const lastNameSliced = lastName.slice(0, 1);

      userName = `${firstNameSliced.toUpperCase()} ${lastNameSliced.toUpperCase()}`;
    }
  }

  return (
    <div>
      <div className="Profile_Col">
        <div>
          <span className="Profile_Name">{userName}</span>
        </div>
      </div>
    </div>
  );
};

export default ProfileCircle;
